import { FrontendItem } from '@portals/sip-client-data/src/general/ApiClientTypes';

export const isLocationBlock = (item: FrontendItem): boolean => {
  return item.name === 'locationData';
};

export const isOtherDataBlock = (item: FrontendItem): boolean => {
  return item.name === 'otherData';
};
